// extracted by mini-css-extract-plugin
module.exports = {"monthCaption":"CustomMonthCaption_monthCaption__h_P_F"};